import React from 'react'
import { Link } from 'react-router-dom'

function ApproveButton({ item, approveMovie }) {
  return (
    <button
      style={{ borderRadius: '7px', marginRight: '2px' }}
      type='button'
      onClick={() => approveMovie(item)}
    >
      <i className='fas fa-upload'></i>
    </button>
  )
}

function EditButton({ item }) {
  return (
    <Link
      data-toggle='tooltip'
      title={'Edit Movie'}
      to={`/editmovie?${item.movieID}`}
      target='_blank'
    >
      <button style={{ borderRadius: '7px', margin: '2px' }} type='button'>
        <i className='fas fa-pencil-alt fa-lg' />
      </button>
    </Link>
  )
}

function DeleteButton({ item, handleDeleteClick }) {
  return (
    <button
      style={{ borderRadius: '7px', margin: '2px' }}
      type='button'
      name={item.PK}
      id={item.SK}
      onClick={() => handleDeleteClick(item)}
    >
      <i className='fas fa-trash fa-lg'></i>
    </button>
  )
}

function ActionsDiv(props) {
  const {
        item,
        handleDeleteClick,
        approveMovie,
        EditApproveOptionPermission,
        DeleteApproveOptionPermission,
        moviePublishingApproveal,
        statusType,
       } = props
  return (
    <div className='buttonFlexAction'>
      {statusType === 'draft' && moviePublishingApproveal && <ApproveButton item={item} approveMovie={approveMovie}/>}
      {EditApproveOptionPermission && <EditButton item={item} />}
      {DeleteApproveOptionPermission && <DeleteButton item={item} handleDeleteClick={handleDeleteClick} />}
    </div>
  )
}

export default ActionsDiv
